import script from "./UpdateRibbon.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateRibbon.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateRibbon.vue?vue&type=style&index=0&id=39b7e05a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b7e05a"]])

export default __exports__